export default __webpack_public_path__ + "static/media/27.2be48ff2.mp3";